import * as React from 'react';
import { Segment, Table as UITable } from 'semantic-ui-react';
export var DateStatistics = function (_a) {
    var detail = _a.detail, children = _a.children;
    return (<div data-testid={detail.type}>
		{children}
		<Segment.Group compact>
			<UITable celled collapsing unstackable>
				<UITable.Body>
					{detail.records.map(function (record, i) { return (<UITable.Row data-testid='record' key={i}>
							<UITable.Cell>{record.value}</UITable.Cell>
							<UITable.Cell textAlign='right'>{record.date}</UITable.Cell>
						</UITable.Row>); })}
				</UITable.Body>
			</UITable>
		</Segment.Group>
	</div>);
};
